import { create } from 'zustand';

export interface Task {
  id: string;
  type: 'merge' | 'upload' | 'deduplicate' | 'download';
  status: 'running' | 'completed' | 'error' | 'cancelled';
  percent: number;
  fileName: string;
  error?: string;
  totalMolecules?: number;
  downloadUrl?: string;  // For download tasks - URL to fetch file when complete
  fileId?: number;       // File ID for download tasks
}

interface TaskStore {
  tasks: Task[];
  isAnyRunning: boolean;

  addTask: (task: Task) => void;
  updateTask: (id: string, updates: Partial<Task>) => void;
  removeTask: (id: string) => void;
  clearCompleted: () => void;
}

export const useTaskStore = create<TaskStore>((set, get) => ({
  tasks: [],
  isAnyRunning: false,

  addTask: (task) => {
    set((state) => {
      const newTasks = [...state.tasks, task];
      return {
        tasks: newTasks,
        isAnyRunning: newTasks.some((t) => t.status === 'running'),
      };
    });
  },

  updateTask: (id, updates) => {
    set((state) => {
      const newTasks = state.tasks.map((t) =>
        t.id === id ? { ...t, ...updates } : t
      );
      return {
        tasks: newTasks,
        isAnyRunning: newTasks.some((t) => t.status === 'running'),
      };
    });
  },

  removeTask: (id) => {
    set((state) => {
      const newTasks = state.tasks.filter((t) => t.id !== id);
      return {
        tasks: newTasks,
        isAnyRunning: newTasks.some((t) => t.status === 'running'),
      };
    });
  },

  clearCompleted: () => {
    set((state) => {
      const newTasks = state.tasks.filter((t) => t.status === 'running');
      return {
        tasks: newTasks,
        isAnyRunning: newTasks.length > 0,
      };
    });
  },
}));
